import { Dropdown, DropdownItem } from "@windmill/react-ui";
import React, { useState, useEffect } from "react";
import cookie from "react-cookies";
import { BeatLoader } from "react-spinners";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetOneUser } from "../api/Actions/ServiceUsers/ServiceUsers";
import { Logout, UsersOrg } from "../api/Actions/SsoB3/SsoB3";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@windmill/react-ui";

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [minimized, setMinimized] = useState(false);
  const [OpenModal, setOpenModal] = useState(false);
  const [loadingLogout, setloadingLogout] = useState(false);
  const menu = useSelector((state) => state.ReduxState.menu);
  const LoginOrg = useSelector((state) => state.UsersLogin.UsersOrg);
  const UserData = useSelector((state) => state.Users.GetOneUser);
  const LogoutData = useSelector((state) => state.UsersLogin.LogoutSession);
  const [SettingModal, setSettingModal] = useState();
  // const [menu, setMenu] = useState("home");
  const handleMenu = (menu) => {
    dispatch({ type: "set", menu: menu });
    navigate(menu);
  };

  const HandleDarkMode = () => {
    if (localStorage.getItem("color-theme") === "") {
      localStorage.setItem("color-theme", "dark");
    } else {
      localStorage.setItem("color-theme", "");
    }
  };

  const handleSelectOrg = (selectedOrg) => {
    if (localStorage.getItem("orgUuid") !== selectedOrg) {
      localStorage.setItem("orgUuid", selectedOrg);
      window.location.reload();
    } else {
    }
  };

  const handleLogout = () => {
    setloadingLogout(true);
    dispatch(Logout());
  };

  useEffect(() => {
    if (!localStorage.getItem("color-theme")) {
      localStorage.setItem("color-theme", "");
    }
    // get user data
    if (localStorage.getItem("identityUuid")) {
      dispatch(GetOneUser(localStorage.getItem("identityUuid")));
    }

    // get users org
    if (!LoginOrg) {
      const userId = localStorage.getItem("identityUuid");
      const param = {
        domain: localStorage.getItem("domain"),
      };
      dispatch(UsersOrg(userId, param));
    }

    if (localStorage.getItem("sessionToken")) {
      handleMenu("/");
    }

    // set sidebar selected menu to current page
    dispatch({ type: "set", menu: window.location.pathname });
  }, []);

  useEffect(() => {
    // handling logout on b3 side and remove all credential on user browser
    if (LogoutData.success === true) {
      localStorage.clear();
      cookie.remove("sessionToken");
      window.location.reload();
    }
  }, [LogoutData]);

  return (
    <div className="flex flex-row">
      <div
        className={
          // (minimized ? "lg:w-20" : "lg:w-64") +
          " w-20 duration-300 flex flex-col justify-between h-full bg-main-blue"
        }
      >
        <div className="mt-40">
          <button
            onClick={(e) => handleMenu("/")}
            className={
              (menu === "/" ? "bg-white text-black" : "text-white hover:bg-gray-500 hover:bg-opacity-20 active:bg-opacity-40") +
              // (minimized ? "" : "") +
              " group duration-300 flex flex-row items-center text-md w-3/4 h-14 sm:h-14 rounded-tr-3xl rounded-br-3xl drop-shadow-xl"
            }
          >
            <i className="fa-solid fa-house mx-auto lg:mx-6 text-lg"></i>
            <span className="group-hover:opacity-100 transition-opacity bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-14 opacity-0 m-4 mx-auto">
              Home
            </span>
            {/* <p
              className={
                (minimized ? "" : "lg:block") +
                " text-xs lg:text-sm poppins-500 hidden"
              }
            >
              Home
            </p> */}
          </button>
          <button
            onClick={(e) => handleMenu("/connector")}
            className={
              (menu === "/connector" ? "bg-white text-black" : "text-white hover:bg-gray-500 hover:bg-opacity-20 active:bg-opacity-40") +
              " group duration-300 flex flex-row items-center text-md w-3/4 h-14 sm:h-14 rounded-tr-3xl rounded-br-3xl drop-shadow-xl"
            }
          >
            <i className="fa-solid fa-circle-nodes mx-auto lg:mx-6 text-xl"></i>
            <span className="group-hover:opacity-100 transition-opacity bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-14 opacity-0 m-4 mx-auto">
              Connector
            </span>
            {/* <p
              className={
                (minimized ? "" : "lg:block") +
                " text-xs lg:text-sm poppins-500 hidden"
              }
            >
              CRM Connector
            </p> */}
          </button>
        </div>
        <div className="">
          <div className="h-16">
            <Dropdown
              isOpen={SettingModal}
              onClose={(e) => {
                dispatch({ type: "set", SettingModal: false });
              }}
              className=""
            >
              <DropdownItem onClick={(e) => setOpenModal(!OpenModal)} className="justify-between">
                <span>Switch Organization</span>
              </DropdownItem>
              <DropdownItem disabled={loadingLogout} onClick={(e) => handleLogout()} className="justify-between">
                {loadingLogout ? <BeatLoader className="my-auto" color="#075985" size={8} /> : <span>Logout</span>}
              </DropdownItem>
            </Dropdown>
          </div>
          <button
            onClick={(e) => setSettingModal(!SettingModal)}
            className="group flex flex-row items-center text-white w-full h-16 mb-4 mx-auto hover:bg-gray-500 hover:bg-opacity-20 border-[2px] border-r-0 border-l-0 border-slate-100 border-2"
          >
            <i className="fa-solid fa-circle-user mx-auto lg:mx-6 text-3xl sm:text-4xl" />
            <p className="poppins-500 text-sm hidden lg:block">{UserData ? UserData.name : ""}</p>
            <span className="group-hover:opacity-100 transition-opacity bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-14 opacity-0 m-4 mx-auto">
              {UserData ? UserData.name : ""}
            </span>
          </button>
          <p className="text-white text-center text-xs">Beta v1.0.0</p>
        </div>
      </div>
      {/* <div className="flex flex-row">
        <button
          onClick={(e) => setMinimized(!minimized)}
          className={
            "flex flex-row items-center text-white text-md w-4 h-7 hidden lg:flex rounded-tr-full rounded-br-full bg-main-blue"
          }
        >
          {minimized ? (
            <i className="fa-solid fa-angle-right mr-2 text-xl"></i>
          ) : (
            <i className="fa-solid fa-angle-left mr-2 text-xl"></i>
          )}
        </button>
      </div> */}
      <Modal
        onClose={(e) => {
          setOpenModal(false);
        }}
        isOpen={OpenModal}
      >
        <ModalHeader>Switch Organization</ModalHeader>
        <ModalBody>
          <div className="overflow-y-auto max-h-80">
            {LoginOrg && LoginOrg.data
              ? LoginOrg.data.organization.rows.map((e, id) => {
                  return (
                    <div
                      key={id}
                      onClick={() => handleSelectOrg(e.orgUuid)}
                      className={
                        (e.orgUuid === localStorage.getItem("orgUuid") ? "border-blue-500" : "") +
                        " flex border border-gray-200 hover:border-blue-500 p-4 mt-2 mx-6"
                      }
                    >
                      <i className="my-auto fa-solid fa-users text-2xl"></i>
                      <p className="my-auto mx-10">{e.name}</p>
                    </div>
                  );
                })
              : ""}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Sidebar;
